import { EventEmitter, Injectable } from "@angular/core";

import { SOCKET_URL } from "./api.service";
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';

@Injectable()
export class SignatureService {
  public api: WebSocketSubject<any>;
  socketEmitter: EventEmitter<number> = new EventEmitter();
  constructor() {    
    
    this.api = webSocket(SOCKET_URL+sessionStorage.getItem("SIGNATURE_ID")+"/");
  }
  connect(){
    this.api.subscribe((res)=>{
      this.socketEmitter.next(res);
    },
    (err) => {
    }
    );
  }
  send(data){
    this.api.next(JSON.stringify(data));
  }
  socket(){
    return this.socketEmitter;
  }
}